import * as types from './types';
import { LOGOUT_SUCCESS } from '../user/types';

const initialState = { filters: [] };

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.SET_NOTE_TYPE_FILTER: {
      const { value } = action.payload;
      return {
        ...state,
        filters: value,
      };
    }
    case types.RESET_NOTE_TYPE_FILTERS:
    case LOGOUT_SUCCESS:
      return initialState;
    default:
      return state;
  }
};
